import {RowType} from "./RowType";

export function getColSpan(rowType, colKey, selectedColumnKeys) {
    if (rowType === RowType.normal)
        return 1;

    if (rowType === RowType.spacer || rowType === RowType.heading) {
        if (colKey === 'date')
            return selectedColumnKeys.length;
        return 0;
    }

    if (rowType === RowType.category_total || rowType === RowType.type_total) {
        const idx = selectedColumnKeys.findIndex(key => key.includes(colKey));
        const amountIdx = selectedColumnKeys.findIndex(key => key.includes('amount'));

        if (colKey === 'date')
            return amountIdx;
        if (idx < amountIdx)
            return 0;
        return 1;
    }
    return 1;
}
